import React from 'react';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { AlertLayer } from '../../packages/alerts/AlertLayer';
import { HandLayer } from '../../packages/hand/HandLayer';
import { HatLayer } from '../../packages/hats/HatLayer';
import { LowerPresentLayer } from '../../packages/presentation/LowerPresentLayer';
import { UpperPresentLayer } from '../../packages/presentation/UpperPresentLayer';
import { ToastLayer } from '../../packages/toast/ToastLayer';
import { ConfettiLayer } from '../ConfettiLayer';
import { EditorPalette } from '../EditorPalette';
import { PointerHandler } from '../PointerHandler';
import { DeveloperView } from '../developer/DeveloperView';
import { OverlayLayer } from '../overlay/OverlayLayer';
import { CaptureWheel, ToolLayer } from '../tooling/ToolLayer';
import { TransformLayer } from '../tooling/transform/TransformLayer';
import { CanvasView } from '../ui/CanvasView';
import { HtmlRenderer } from '../visualization/HtmlRenderer';
import { PasteSupport } from '../workspace/PasteSupport';
import { AdapterLayer } from '../workspace/adapters/AdapterLayer';
import { PawnLayer } from '../workspace/participants/PawnLayer';
import { WidgetLayer } from '../workspace/widgets/WidgetLayer';
import { KioskEditorScope } from './KioskEditorScope';
import { KioskPackage } from './KioskPackage';

export const KioskPage = () => {

    return <Flexer>
        <KioskEditorScope packages={[KioskPackage]}>
            <CanvasView>
                <HtmlRenderer />
                <PointerHandler />
                <CaptureWheel>
                    <ToolLayer />
                </CaptureWheel>
                <HandLayer />
                <OverlayLayer />
                <ConfettiLayer />
                <PawnLayer />
                <HatLayer />
                <LowerPresentLayer />
                <TransformLayer />
                <CaptureWheel>
                    <AdapterLayer />
                    <WidgetLayer />
                </CaptureWheel>
                <AlertLayer />
                <ToastLayer />
                <PasteSupport />
                <DeveloperView />
                <EditorPalette />
            </CanvasView>
            <UpperPresentLayer />
        </KioskEditorScope>
    </Flexer>;
};
